import React, { Component } from "react";
import { ArrowIcon } from "../../assets/Icons";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";
import NoDataFound from "../../common/NoDataFound";

class AssignedWorkedFlow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      toggleActive: false,
    };
  }

  toggleActive = () => {
    this.setState((prevState) => ({
      active: !prevState.active,
    }));
  };

  render() {
    const { active } = this.state;
    const { newVersion, taskCreate } = this.props;

    return (
      <>
        <HeaderMobileSearch showFilterBtn={false} backBtn={true} searchAnimated={false} searchMode={false} />
        <div className="assignedflowlist">
          <h4 className="px-3 pb-3">Workflow Version List</h4>
          {newVersion && newVersion.length > 0 ? (
            newVersion.map((version, index) => (
              <div
                className="workcard"
                key={index}
                onClick={() => taskCreate(version)}
              >
                <div className="left">
                  <div className="work-detail">
                    <span className="work-heading">V{version.version}</span>
                  </div>
                  <p className="work-content">{version.publishDate}</p>
                </div>
                <div className="right">
                  {version.publish_status === 1 ? (
                    <div className="live-banner">Live</div>
                  ) : (
                    <div className="live-banner inactive-banner">Inactive</div>
                  )}
                  <ArrowIcon />
                </div>
              </div>
            ))
          ) : (
            <NoDataFound headText="No data found" />
          )}
        </div>
      </>
    );
  }
}

export default AssignedWorkedFlow;
